/* eslint-disable1 */
import React, { useState, useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'
import classnames from 'classnames'
import { videoPlayerIcons } from '../../helpers/iconHelpers'
import CustomButton from '../../CustomButton'
import Controls from '../../Controls'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import { useTranslation } from 'react-i18next'

const PermalinkSnapshots = (props) => {
	const { snapshotUrls } = props;
	const { t } = useTranslation();
	// const [windowHeight, setWindowHeight] = useState(560)
	// const [windowWidth, setWindowWidth] = useState(900)
	const [activeChannel, setActiveChannel] = useState(1)
	// const [channelAudio, setChannelAudio] = useState(2)
	const [showChannelsSelection, setShowChannelsSelection] = useState(false)
	const [showZoomControls, setShowZoomControls] = useState(false)
	// const PlayerVideoHeight = document.getElementById('player-container') ? document.getElementById('player-container').offsetHeight + 1 : windowHeight
	const videosLength = snapshotUrls && snapshotUrls.length

	useEffect(() => {
		//* Only for iOS devices display channel selection to playback video because they can not to mutiple playback
		if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
			setShowChannelsSelection(true)
		}
		// ******

		// setWindowWidth(window.innerWidth - window.innerWidth * 0.2)
		// setWindowHeight(window.innerHeight - window.innerHeight * 0.2)
	}, [])

	useEffect(() => {
		if (showZoomControls) {
			$(document).mouseup((e) => { if (($('.vjs-zoom__container')[0] && !$('.vjs-zoom__container')[0].contains(e.target)) && !$('.btn-zoom')[0].contains(e.target)) { setShowZoomControls(false) } });
		}
	}, [showZoomControls])

	const video1 = (<div
		className={classnames('channel channel1')}
		onDoubleClick={() => changeActiveChannel(1)}
	>
		<h1 style={{ lineHeight: 0 }}>
			<img id="channel1" data-channel="1" src={snapshotUrls[0]} />
		</h1>
	</div>);
	const video2 = (videosLength > 1) && (
		<div
			className={classnames('channel channel2')}
			onDoubleClick={() => changeActiveChannel(2)}
		>
			<h1>
				<img id="channel2" data-channel="2" src={snapshotUrls[1]} />
			</h1>
		</div>);
	const video3 = (videosLength > 2) ? (
		<div
			className={classnames('channel channel3')}
			onDoubleClick={() => changeActiveChannel(3)}
		>
			<h1>
				<img id="channel3" data-channel="3" src={snapshotUrls[3]} />
			</h1>
		</div>) :
		<div className='empty-channel' />;
	const video4 = (videosLength > 3) ? (
		<div
			className={classnames('channel channel4')}
			onDoubleClick={() => changeActiveChannel(4)}
		>
			<h1>
				<img id="channel4" data-channel="4" src={snapshotUrls[4]} />
			</h1>
		</div>) :
		<div className='empty-channel' />;

	const getVideoChannel = (position) => {
		switch (activeChannel) {
			case 1:
				if (position === 1) return video1;
				if (position === 2) return video2;
				if (position === 3) return video3;
				if (position === 4) return video4;
				break
			case 2:
				if (position === 1) return video2;
				if (position === 2) return video1;
				if (position === 3) return video3;
				if (position === 4) return video4;
				break
			case 3:
				if (position === 1) return video3;
				if (position === 2) return video1;
				if (position === 3) return video2;
				if (position === 4) return video4;
				break
			case 4:
				if (position === 1) return video4;
				if (position === 2) return video1;
				if (position === 3) return video2;
				if (position === 4) return video3;
				break
		}
	}

	const changeActiveChannel = (channelSelected) => {
		setActiveChannel(channelSelected)
	}

	const element = document.getElementsByTagName('img')[0];
	const style = { bottom: '1.8rem', right: '0px' };

	return (
		// <div className="modal-body" style={{ height: `${windowHeight}px` }}>
		<div className="modal-body">
			{/* <div id="advanced-web-player" className='permalink' style={!isMobileOnly ? { height: `calc(${PlayerVideoHeight}px` } : {}}> */}
			<div id="advanced-web-player" className='permalink'>
				<div className="col-md-12 col-xs-12 col-sm-12 no-padding video-column">
					{/* <div id="player-video" style={{ width: '100%', height: PlayerVideoHeight }}> */}
					<div id="player-video">
						{(snapshotUrls.length > 0) &&
							<div id='player-container'>
								<div className='channel1-wrapper'>
									<TransformWrapper>
										<Controls
											element={element}
											style={style}
											changeChannel={activeChannel}
											showZoomControls={showZoomControls}
										/>
										<TransformComponent>
											{getVideoChannel(1)}
										</TransformComponent>
									</TransformWrapper>
									<div className="video-slider">
										<CustomButton variant="link" prefix="btn-zoom" style={{ position: 'absolute', right: '0', bottom: '0' }} onClick={() => setShowZoomControls(!showZoomControls)} >
											{videoPlayerIcons.zoomIcon}
										</CustomButton>
									</div>
								</div>
								{/* <div className={classnames('wrapper', { 'single-channel': (snapshotUrls.length == 1) }, { 'small-width': (windowWidth < 800) })}> */}
								<div className={classnames('wrapper', { 'single-channel': (snapshotUrls.length == 1) })}>
									{getVideoChannel(2)}
									{getVideoChannel(3)}
									{getVideoChannel(4)}
									<div className="tooltipDoubleClick">
										{t('permalinksPage.advancedPlayerOpenClip.tooltipDoubleClickSnapshots')}
									</div>
								</div>
							</div>
						}
					</div>

					{showChannelsSelection &&
						<div style={{ textAlign: 'center', marginTop: '10px' }}>
							<ul className="list-inline chanels-list">
								{_.times(snapshotUrls.length, i =>
									<li key={i}
										className={classnames('list-inline-item', { 'active': activeChannel === (i + 1) })}
									>
										<a href="javascript:void(0)" onClick={() => changeActiveChannel(i + 1)}>
											{i + 1}
										</a>
									</li>
								)}
							</ul>
						</div>
					}
				</div>
			</div>
		</div>
	)
}

export default PermalinkSnapshots;
